const noop = () => {}

const openInNewTab = (url: string | undefined): void => {
  if (!url) return
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const displayNotificationCount = (count: number | undefined | null): string => {
  if (!count) {
    return ''
  } else if (count > 0 && count < 100) {
    return `(${count})`
  } else {
    return '(99+)'
  }
}

const setDocumentTitle = (count: number | undefined | null): void => {
  const displayCount = displayNotificationCount(count)

  document.title = displayCount ? `${displayCount} Mango` : 'Mango'
}

const decodeBase64 = (base64: string) => {
  return atob(base64)
}

//JWT segments are base64url-encoded; normalize before atob so payloads
//containing '-'/'_' decode instead of throwing.
const decodeJwtPayload = (
  accessToken: string,
): { exp?: unknown; iat?: unknown } => {
  const payload = accessToken
    .split('.')[1]
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  return JSON.parse(decodeBase64(payload)) as { exp?: unknown; iat?: unknown }
}

const getAccessTokenExpiryMs = (accessToken: string): number | null => {
  try {
    const expiryMs = Number(decodeJwtPayload(accessToken).exp) * 1000
    return Number.isFinite(expiryMs) ? expiryMs : null
  } catch {
    return null
  }
}

// iat must be a plain epoch-seconds number: Number() would accept null, '',
// true or a millisecond value and produce an absurd clock skew.
const getAccessTokenIssuedAtMs = (accessToken: string): number | null => {
  try {
    const { iat } = decodeJwtPayload(accessToken)
    return typeof iat === 'number' && iat > 0 && iat < 1e11 ? iat * 1000 : null
  } catch {
    return null
  }
}

const isAccessTokenExpired = (accessToken: string) => {
  try {
    //a payload without a numeric exp claim never expires (NaN comparison is
    //false); an undecodable token is treated as expired.
    return Number(decodeJwtPayload(accessToken).exp) * 1000 < Date.now()
  } catch {
    return true
  }
}

const isClickToCallName = (name: string) => {
  const regex = /^C2C-\+?[1-9]\d{1,14}$/
  return regex.test(name)
}

export {
  noop,
  openInNewTab,
  displayNotificationCount,
  setDocumentTitle,
  decodeBase64,
  getAccessTokenExpiryMs,
  getAccessTokenIssuedAtMs,
  isAccessTokenExpired,
  isClickToCallName,
}
